<template lang="pug">
    .ui

        .ui__selectors(
            :class='{visible: articlesOnScreen}'
            )

            .ui__selectors-selector(
                v-for='(article, name) in articles',
                :key='name',
                :class='[`theme-${article.color}`, {active: articleActive === name}]',
                @click='emitArticleChange(name)',
                )

</template>

<script>
export default {
    name: 'Ui',

    props: {
        articles: Object,
        articleActive: String,
        articlesOnScreen: Boolean
    },

    methods: {
        emitArticleChange(name) {
            this.$emit('update:articleActive', name);
            this.$emit('scrollToArticles');
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';

.ui {
    position: fixed;
    z-index: 50;
    width: 100%;
    height: 100vh;
    height: calc(var(--vh) * 100);
    pointer-events: none;

    &__logo {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: calc(var(--block-height) * 2);

        @media (--viewport-tablet) {
            padding: 20px;
        }

        &--sf,
        &--sb {
            cursor: pointer;
            pointer-events: all;
        }

        &--sf {
            svg {
                width: 100px;
                height: 50px;

                @media (--viewport-tablet) {
                    width: 25vw;
                }
            }
        }

        &--sb {
            svg {
                width: 150px;
                height: 50px;

                @media (--viewport-tablet) {
                    width: 35vw;
                }
            }
        }
    }

    &__selectors {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.6s ease;

        &.visible {
            opacity: 1;
            pointer-events: all;
        }

        @media (--viewport-tablet) {
            width: 100%;
            height: calc(var(--block-height) + 20px);
            background: var(--color-green);
            flex-direction: row;
        }

        &-selector {
            width: var(--block-height);
            height: var(--block-height);
            border: 3px solid var(--theme);
            border-left: none;
            margin: 30px 0;
            cursor: pointer;
            pointer-events: all;
            transition: background 0.6s ease;

            &.active {
                background-color: var(--theme);
            }

            @media (--viewport-tablet) {
                margin: 10px 30px;
                border: 3px solid var(--theme);
            }
        }
    }
}
</style>
